import { render, staticRenderFns } from "./moveRecord.vue?vue&type=template&id=81f4dc3c&scoped=true&"
import script from "./moveRecord.vue?vue&type=script&lang=js&"
export * from "./moveRecord.vue?vue&type=script&lang=js&"
import style0 from "./moveRecord.vue?vue&type=style&index=0&id=81f4dc3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f4dc3c",
  null
  
)

export default component.exports